export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq4-Report-PDF-Pg9.f507b9e0.png";